import axios from 'axios';
import { API_BASE_URL } from '@config';

// Action Types
export const GET_DASHBOARD_METRICS_REQUEST = 'GET_DASHBOARD_METRICS_REQUEST';
export const GET_DASHBOARD_METRICS_SUCCESS = 'GET_DASHBOARD_METRICS_SUCCESS';
export const GET_DASHBOARD_METRICS_FAILURE = 'GET_DASHBOARD_METRICS_FAILURE';

export const GET_USER_PREFERENCES_REQUEST = 'GET_USER_PREFERENCES_REQUEST';
export const GET_USER_PREFERENCES_SUCCESS = 'GET_USER_PREFERENCES_SUCCESS';
export const GET_USER_PREFERENCES_FAILURE = 'GET_USER_PREFERENCES_FAILURE';

export const UPDATE_USER_PREFERENCES_REQUEST = 'UPDATE_USER_PREFERENCES_REQUEST';
export const UPDATE_USER_PREFERENCES_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS';
export const UPDATE_USER_PREFERENCES_FAILURE = 'UPDATE_USER_PREFERENCES_FAILURE';

export const PIN_APPLICATION_REQUEST = 'PIN_APPLICATION_REQUEST';
export const PIN_APPLICATION_SUCCESS = 'PIN_APPLICATION_SUCCESS';
export const PIN_APPLICATION_FAILURE = 'PIN_APPLICATION_FAILURE';

export const UNPIN_APPLICATION_REQUEST = 'UNPIN_APPLICATION_REQUEST';
export const UNPIN_APPLICATION_SUCCESS = 'UNPIN_APPLICATION_SUCCESS';
export const UNPIN_APPLICATION_FAILURE = 'UNPIN_APPLICATION_FAILURE';

export const UPDATE_DASHBOARD_METRICS_REALTIME = 'UPDATE_DASHBOARD_METRICS_REALTIME';

export const GET_USER_DASHBOARD_METRICS_REQUEST = 'GET_USER_DASHBOARD_METRICS_REQUEST';
export const GET_USER_DASHBOARD_METRICS_SUCCESS = 'GET_USER_DASHBOARD_METRICS_SUCCESS';
export const GET_USER_DASHBOARD_METRICS_FAILURE = 'GET_USER_DASHBOARD_METRICS_FAILURE';

// Action Creators

/**
 * Get dashboard metrics (admin only)
 */
export const getDashboardMetrics = () => dispatch => {
	dispatch({ type: GET_DASHBOARD_METRICS_REQUEST });

	return axios
		.get(`${API_BASE_URL}/api/dashboard/metrics`)
		.then(response => {
			dispatch({
				type: GET_DASHBOARD_METRICS_SUCCESS,
				payload: response.data.data
			});
			return response.data.data;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch dashboard metrics';
			dispatch({
				type: GET_DASHBOARD_METRICS_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Get user dashboard metrics (for non-admin users)
 */
export const getUserDashboardMetrics = () => dispatch => {
	dispatch({ type: GET_USER_DASHBOARD_METRICS_REQUEST });

	return axios
		.get(`${API_BASE_URL}/api/dashboard/user-metrics`)
		.then(response => {
			dispatch({
				type: GET_USER_DASHBOARD_METRICS_SUCCESS,
				payload: response.data.data
			});
			return response.data.data;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch user dashboard metrics';
			dispatch({
				type: GET_USER_DASHBOARD_METRICS_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Get user dashboard preferences
 */
export const getUserPreferences = () => dispatch => {
	dispatch({ type: GET_USER_PREFERENCES_REQUEST });

	return axios
		.get(`${API_BASE_URL}/api/users/dashboard-preferences`)
		.then(response => {
			const prefs = response.data.data;
			// Save to localStorage for quick access
			localStorage.setItem('dashboardPreferences', JSON.stringify(prefs));
			
			dispatch({
				type: GET_USER_PREFERENCES_SUCCESS,
				payload: prefs
			});
			return prefs;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch user preferences';
			dispatch({
				type: GET_USER_PREFERENCES_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Update user dashboard preferences
 */
export const updateUserPreferences = (updates) => dispatch => {
	dispatch({ type: UPDATE_USER_PREFERENCES_REQUEST });

	return axios
		.put(`${API_BASE_URL}/api/users/dashboard-preferences`, updates)
		.then(response => {
			const prefs = response.data.data;
			// Save to localStorage for immediate access
			localStorage.setItem('dashboardPreferences', JSON.stringify(prefs));
			
			dispatch({
				type: UPDATE_USER_PREFERENCES_SUCCESS,
				payload: prefs
			});
			return prefs;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to update preferences';
			dispatch({
				type: UPDATE_USER_PREFERENCES_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Pin application to dashboard
 */
export const pinApplication = (applicationData) => dispatch => {
	dispatch({ type: PIN_APPLICATION_REQUEST });

	// Send full application object instead of just ID
	return axios
		.post(`${API_BASE_URL}/api/users/dashboard-preferences/pin-application`, { applicationData })
		.then(response => {
			dispatch({
				type: PIN_APPLICATION_SUCCESS,
				payload: response.data.data
			});
			return response.data.data;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to pin application';
			dispatch({
				type: PIN_APPLICATION_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Unpin application from dashboard
 */
export const unpinApplication = (applicationId) => dispatch => {
	dispatch({ type: UNPIN_APPLICATION_REQUEST });

	return axios
		.delete(`${API_BASE_URL}/api/users/dashboard-preferences/unpin-application/${applicationId}`)
		.then(response => {
			dispatch({
				type: UNPIN_APPLICATION_SUCCESS,
				payload: response.data.data
			});
			return response.data.data;
		})
		.catch(error => {
			const errorMessage = error.response?.data?.error || error.message || 'Failed to unpin application';
			dispatch({
				type: UNPIN_APPLICATION_FAILURE,
				payload: errorMessage
			});
			throw error;
		});
};

/**
 * Update dashboard metrics from real-time socket event
 */
export const updateDashboardMetricsRealtime = (metricsData) => ({
	type: UPDATE_DASHBOARD_METRICS_REALTIME,
	payload: metricsData
});
